import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

interface ProtectedRouteProps {
  element: React.ComponentType<any> | React.ReactElement;
  requiredRole?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element: Element, requiredRole }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Add role-based protection logic here if needed
  if (requiredRole) {
    // const admin = getStoredAdmin();
    // if (admin?.role !== requiredRole) {
    //   return <Navigate to="/dashboard" replace />;
    // }
  }

  return typeof Element === 'function' ? <Element /> : Element;
};

export default ProtectedRoute;
